"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealedEventArgs = void 0;
const EventType_1 = require("../EventType");
class HealedEventArgs {
    constructor(healedBy, healedAmount) {
        this.healedBy = healedBy;
        this.healedAmount = healedAmount;
        this.__type = EventType_1.EventType.Healed;
        this.__typeName = "Healed";
    }
}
exports.HealedEventArgs = HealedEventArgs;
